module.exports = __webpack_public_path__ + "static/media/Header2.be8882cb.jpg";